import { AttestationSummary } from '@/typings';
import { adaptDecimalValueToPercentage } from '../utilities';
import { FieldsSummaryResponseDTO } from '@/api/base/DTOs';

export const adaptAttestationFieldSummaryResponseToApplicationAttestationSummary =
  (
    attestationSummaryResponse: FieldsSummaryResponseDTO,
  ): AttestationSummary => {
    return {
      fieldsCount: attestationSummaryResponse.fieldsCount,
      pendingFieldsCount: attestationSummaryResponse.pendingFieldsCount,
      requiredFieldsCount: attestationSummaryResponse.requiredFieldsCount,
      pendingRequiredFieldsCount:
        attestationSummaryResponse.pendingRequiredFieldsCount,
      restrictionViolationsCount:
        attestationSummaryResponse.restrictionViolationsCount,
      completedPercentage: adaptDecimalValueToPercentage(
        attestationSummaryResponse.completedPercentage,
      ),
    };
  };
